import { Box, Stack, Theme } from '@mui/material';
import { ReactNode, FC } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '../../text';
import classNames from 'classnames';
import { IconType } from '@/components/icon/helpers';
import Icon from '@/components/icon';

interface Props {
  icon?: IconType;
  title: ReactNode;
  className?: string;
  expanded?: boolean;
  onClick?: () => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  header: {
    paddingLeft: 18,
    marginBottom: 4,
    color: theme.palette.text.primary,
    '& .title': {
      lineHeight: '100%',
      paddingTop: 2,
    },
  },
  expand: {
    cursor: 'pointer',
  },
}));

const SidebarListItemHeader: FC<Props> = ({
  title,
  className,
  icon,
  onClick,
  expanded = false,
}) => {
  const canExpand = !!onClick;
  const styles = useStyles();
  const compClass = classNames(styles.header, className);
  const hasIcon = !!icon;

  return (
    <Box className={compClass}>
      <Stack
        direction="row"
        gap={0.5}
        alignItems="center"
        justifyContent="flex-start"
        onClick={canExpand ? onClick : undefined}
        role={canExpand ? 'button' : undefined}
        tabIndex={canExpand ? 0 : undefined}
        aria-expanded={expanded}
        width="fit-content"
        className={classNames(canExpand && styles.expand)}
      >
        {hasIcon && <Icon size="x-small" name={icon} />}
        <Text size="small" className="title" bold>
          {title}
        </Text>

        {canExpand && <Icon size="x-small" name={expanded ? 'expand-more' : 'chevron-right'} />}
      </Stack>
    </Box>
  );
};

export default SidebarListItemHeader;
